import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BnAlertsService } from '@bndes/bndes-ux4/bn-alerts';
import { ModalidadeScrService } from '../modalidade-scr.service';
import { BnLoadingService } from '@bndes/bndes-ux4/bndes-angular-utils';
import { ObjetivoFinanciamentoLista, TipoClienteLista } from 'src/app/model/modalidade-scr.model';

@Component({
  selector: 'app-modalidade-scr-cadastro',
  templateUrl: './modalidade-scr-cadastro.component.html',
  styleUrls: ['./modalidade-scr-cadastro.component.scss'],
  standalone: false
})
export class ModalidadeScrCadastroComponent implements OnInit {

  public form: UntypedFormGroup;

  public listaTiposModalidade = ObjetivoFinanciamentoLista;

  public listaTiposCliente = TipoClienteLista;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private alertsService: BnAlertsService,
    private servico: ModalidadeScrService,
    private loadingService: BnLoadingService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      codigoScrModalidade: [null, [Validators.required, Validators.pattern('^[0-9]*$')]],
      tipoScrModalidade: [null, Validators.required],
      tipoCliente: [null, Validators.required],
      nomeScrModalidade: [null, Validators.required]
    });
  }

  public salvar(): void {
    if (this.form.valid) {
      this.servico.salvar(this.form.value).subscribe(() => {
        this.alertsService.alertaSucesso('Sucesso', 'Cadastro realizado com sucesso');
        this.loadingService.liberaTela();
        this.router.navigate(['/modalidade-scr/pesquisa']);
      })
    }
  }

  public cancelar(): void {
    this.router.navigate(['/modalidade-scr/pesquisa']);
  }
}